export const agentInitialState = {
  activeSessions: [],
  availableAgents: [],
  isLoading: false
};

export const agentPollingConfig = {
  pollIntervalMs: 2000,
  maxPollAttempts: 90
};
